import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Shortcutter from 'mixins/shortcuts';
import { IconButton } from 'react-toolbox';
import ActivableRenderer from 'components/ActivableRenderer';
import cx from 'classnames';
import styles from './styles.scss';

class ComposeWindow extends Shortcutter(Component, [
  { key: 'esc', func: 'handleCloseShortcut' },
]) {
  state = { minimized: false };

  toggleMin = () => this.setState({ minimized: !this.state.minimized })
  handleCloseShortcut = () => this.props.onClose()

  render() {
    const props = this.props;
    const { minimized } = this.state;
    const className = cx(props.className, styles.wrapper, { [styles.minimized]: minimized });
    return (
      <div className={className}>
        <section className={styles.body}>
          <div className={styles.title}>
            <h6>{props.title}</h6>
            <IconButton
              icon={minimized ? 'keyboard_arrow_up' : 'remove'}
              className={styles.headerButton}
              onClick={this.toggleMin}
              tabIndex={-1}
            />
            <IconButton
              icon="close"
              className={styles.headerButton}
              onClick={props.onClose}
              tabIndex={-1}
            />
          </div>
          <div className={styles.content}>
            {props.children}
          </div>
        </section>
      </div>
    );
  }
}

ComposeWindow.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onClose: PropTypes.func,
  title: PropTypes.string,
};

export default ActivableRenderer()(ComposeWindow);



// WEBPACK FOOTER //
// ./client/app/shared/components/ComposeWindow/index.jsx